import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { Link, Text, TUILink } from '../../ui';

type Props = {
  activeResumeId: string;
  isDark: boolean;
};

const NavLinks = React.memo<Props>(function NavLinks({
  activeResumeId,
  isDark,
}: Props) {
  return (
    <>
      <NavLink
        to={`/resumes/${activeResumeId}/write`}
        isDark={isDark}
        id="gi-nav-write"
      >
        Edit
      </NavLink>
      <NavLink
        to={`/resumes/${activeResumeId}/preview`}
        isDark={isDark}
        id="gi-nav-preview"
      >
        Design
      </NavLink>
      <NavLink
        to={`/resumes/${activeResumeId}/share`}
        isDark={isDark}
        id="gi-nav-share"
      >
        Share
      </NavLink>
      <NavLink
        to="https://learn.standardresume.co"
        isDark={isDark}
        id="gi-nav-learn"
      >
        Learn
      </NavLink>
    </>
  );
});

type NavLinkProps = {
  to: string;
  children: React.ReactNode;
  isDark: boolean;
  id: string;
};

const NavLink = ({ to, children, isDark, id }: NavLinkProps) => {
  const location = useLocation();
  const active = location.pathname === to;
  const styles = {
    color: isDark
      ? active
        ? 'white'
        : 'white50'
      : active
      ? 'black'
      : 'black50',
    textDecoration: active ? 'underline' : 'none',
    transition: 'color 150ms ease-in-out',
    fontWeight: 'bold',
    fontSize: [14, 15, 20],
    lineHeight: '56px',
    px: [12, 12, 20],
  };
  if (to.includes('http')) {
    return (
      <TUILink href={to} target="_blank" sx={styles} id={id}>
        {children}
      </TUILink>
    );
  }
  return (
    <Link to={to} sx={{ textDecoration: 'none' }} id={id}>
      <Text sx={styles}>{children}</Text>
    </Link>
  );
};

export default NavLinks;
